import { render } from "./sellerCard.vue?vue&type=template&id=5a40ef14&scoped=true"
import script from "./sellerCard.vue?vue&type=script&lang=js"
export * from "./sellerCard.vue?vue&type=script&lang=js"

import "./sellerCard.vue?vue&type=style&index=0&id=5a40ef14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a40ef14"]])

export default __exports__